var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "dashboard px-6", attrs: { fluid: "" } },
    [
      _c(
        "section-title",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", align: "center" } },
            [
              _c("img", {
                staticClass: "mr-2",
                attrs: {
                  src: require("@/assets/IconEC.svg"),
                  width: "35px",
                  height: "35px"
                }
              }),
              _c("div", { staticClass: "pl-2" }, [_vm._v("Equipos")]),
              _c("v-spacer"),
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                staticClass: "hidden-sm-and-down",
                                attrs: { color: "green", dark: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.reRenderEquipmentForm()
                                  }
                                }
                              },
                              on
                            ),
                            [_vm._v("REGISTRAR EQUIPO")]
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c("EquipmentForm", {
                    key: _vm.equipmentFormKey,
                    attrs: {
                      createEquipment: _vm.createMode,
                      buildingsDataCentersList: _vm.dataCentersAndBuildings,
                      equipmentToUpdate: _vm.equipmentToUpdate
                    },
                    on: { closeDialog: _vm.closeDialog }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "borderbox d-flex justify-space-between elevation-1 pb-n7 align-center"
                    },
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "8", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "prepend-inner-icon": "mdi-magnify",
                                      label: "Buscar",
                                      "single-line": "",
                                      "hide-details": "",
                                      clearable: ""
                                    },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.getEquipments()
                                      }
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4", md: "3" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "white--text mr-2 mt-5",
                                      attrs: {
                                        color: "green",
                                        disabled: _vm.loadingEquipments
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.getEquipments()
                                        }
                                      }
                                    },
                                    [_vm._v(" Buscar ")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mb-n4 mt-n3",
                                  attrs: { cols: "6", md: "3" }
                                },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "mb-0" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex justify-center overline mb-0",
                                          staticStyle: {
                                            "font-size": "80% !important"
                                          },
                                          attrs: { cols: "12" }
                                        },
                                        [_vm._v(" DATA CENTER ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { staticClass: "mt-n7" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex justify-center mt-0",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.dataCenterOptions,
                                              "auto-select-first": "",
                                              "item-value": "id",
                                              "item-text": "name",
                                              "no-data-text":
                                                "No se encontraron resultados",
                                              color: "blue-grey lighten-2",
                                              label:
                                                "Selecciona un data center",
                                              "single-line": "",
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.dataCenterOption,
                                              callback: function($$v) {
                                                _vm.dataCenterOption = $$v
                                              },
                                              expression: "dataCenterOption"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mb-n4 mt-n3",
                                  attrs: { cols: "6", md: "3" }
                                },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "mb-0 px-0 mx-0" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex justify-center overline",
                                          staticStyle: {
                                            "font-size": "80% !important"
                                          },
                                          attrs: { cols: "12" }
                                        },
                                        [_vm._v(" INSTALACIÓN ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { staticClass: "mt-n7" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex justify-center mx-0",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c(
                                            "v-form",
                                            {
                                              ref: "form1",
                                              staticStyle: {
                                                width: "334.047px"
                                              }
                                            },
                                            [
                                              _c("v-autocomplete", {
                                                attrs: {
                                                  items: _vm.buildingOptions,
                                                  "auto-select-first": "",
                                                  "item-value": "id",
                                                  "item-text": "name",
                                                  "no-data-text":
                                                    "No se encontraron resultados",
                                                  color: "blue-grey lighten-2",
                                                  label:
                                                    "Selecciona una instalación",
                                                  "single-line": "",
                                                  clearable: ""
                                                },
                                                model: {
                                                  value: _vm.buildingOption,
                                                  callback: function($$v) {
                                                    _vm.buildingOption = $$v
                                                  },
                                                  expression: "buildingOption"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-container",
                    { staticClass: "align-center", attrs: { fluid: "" } },
                    [
                      !_vm.loadingEquipments
                        ? _c(
                            "v-row",
                            _vm._l(_vm.equipmentsResult.results, function(
                              equipment,
                              index
                            ) {
                              return _c(
                                "v-col",
                                {
                                  key: "E" + index,
                                  attrs: { cols: "12", md: "6", lg: "4" }
                                },
                                [
                                  _c("EquipmentCard", {
                                    staticClass: "equipmentCard",
                                    attrs: {
                                      equipmentItem: equipment,
                                      updatePrivilege: true,
                                      deletePrivilege: true
                                    },
                                    on: {
                                      updateEquipment: _vm.updateEquipment,
                                      deleteEquipment: _vm.setEquipmentDeletion
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _c(
                            "v-row",
                            _vm._l(6, function(n, index) {
                              return _c(
                                "v-col",
                                {
                                  key: "SL" + index,
                                  attrs: { cols: "12", md: "6", lg: "4" }
                                },
                                [
                                  _c("v-skeleton-loader", {
                                    attrs: { type: "image" }
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "grey lighten-4 ma-0 py-2" },
                    [
                      _c("v-pagination", {
                        attrs: { length: _vm.pages, "total-visible": 7 },
                        on: {
                          input: function($event) {
                            return _vm.getEquipments()
                          }
                        },
                        model: {
                          value: _vm.page,
                          callback: function($$v) {
                            _vm.page = $$v
                          },
                          expression: "page"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800" },
          model: {
            value: _vm.deleteDialog,
            callback: function($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog"
          }
        },
        [
          _c(
            "v-container",
            { staticClass: "white py-0 pb-5", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "modal-title white--text d-flex justify-space-between align-center"
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "d-flex align-center font-weight-regular"
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("mdi-delete")
                          ]),
                          _vm._v("Eliminar equipo ")
                        ],
                        1
                      ),
                      _c(
                        "v-icon",
                        {
                          attrs: { dark: "" },
                          on: {
                            click: function($event) {
                              _vm.deleteDialog = false
                            }
                          }
                        },
                        [_vm._v("mdi-close")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.deletingEquipment
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c("br"),
                          _c(
                            "h2",
                            {
                              staticClass: "headline",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _vm._v(
                                " ¿Estás seguro que deseas eliminar al siguiente equipo? "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c("img", {
                            staticClass: "mr-2",
                            attrs: {
                              src: require("@/assets/IconE.svg"),
                              width: "100px",
                              height: "100px"
                            }
                          })
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "h2",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.equipmentToDelete.name) + " "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "title font-weight-regular",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _vm._v(
                                " Si procede no podrá recuperar la información de este equipo "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex flex-row-reverse",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text mr-7",
                              attrs: { color: "green" },
                              on: {
                                click: function($event) {
                                  _vm.deleteDialog = false
                                }
                              }
                            },
                            [_vm._v("Cancelar")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text mr-7",
                              attrs: { color: "green" },
                              on: { click: _vm.deleteEquipment }
                            },
                            [_vm._v("Eliminar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : !_vm.equipmentDeleted
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center align-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "v-progress-circular",
                            {
                              attrs: {
                                size: 200,
                                width: 7,
                                color: "success",
                                indeterminate: ""
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "green", size: 50 } },
                                [_vm._v("mdi-server")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "d-flex justify-center align-center display-1",
                            staticStyle: { "text-align": "center" }
                          },
                          [_vm._v(" " + _vm._s(_vm.loadingText) + " ")]
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }